import { Card, Modal, message } from 'antd'
import { CButton } from 'app/components/Common'
import { COLORS } from 'app/constants'
import { useTradeModalStore } from 'app/hooks/trade/modalStore'
import React from 'react'
import { Text, View } from '../../../styles/reactnative'
import { WarningFilled } from '@ant-design/icons'
import Contracts from './Contracts'
import Price from './Price'
import Unrealizedplpercent from './Unrealizedplpercent'
import Quantity from './Quantity'
import UserTag from '../UserTag'
import API from '../../../utils/api'
import { useToken } from '../../hooks'

interface ClosePositionProps {
	data: any
	onClick: () => void
	zindex?: number
	onSuccess?: () => void
}

const ClosePosition = ({ data, onClick, zindex = 998, onSuccess }: ClosePositionProps) => {
	const [open, setOpen] = React.useState(false)
	const { data: token } = useToken()

	const sendOrder = async data => {
		const orderParams = {
			user_id: data?.user_id,
			ep_id: data?.exchange_pairs_id,
			main_sub: 'M',
			long_short: data?.long_short === 'L' ? 'S' : 'L',
			cross_iso: data?.cross_iso,
			leverage: data?.leverage,
			reduce_position: 1,
			post_only: 0,
			limit_market: 'M',
			price: data?.price,
			amount: data?.amount,
		}

		try {
			const result = await API.post(
				'/admin/trade/order',
				'' + token,
				orderParams
			)

			if (result?.result?.success) {
				message.success('포지션 종료가 완료되었습니다.')
				// 성공 시 콜백 실행 (데이터 새로고침)
				onSuccess && onSuccess()
			} else {
				result?.result?.message &&
					message.error(result?.result?.message)
			}
		} catch (e) {
			message.error('포지션 종료에 실패하였습니다.')
		}
		setOpen(false)
	}

	return (
		<>
			<Modal
				title={'강제 포지션종료'}
				open={open}
				cancelText="취소"
				okText="확인"
				okButtonProps={{
					style: {
						margin: 0,
						background: COLORS.lightRed,
						color: COLORS.white,
					},
				}}
				zIndex={zindex}
				onCancel={() => {
					setOpen(false)
				}}
				onOk={() => {
					sendOrder(data)
				}}>
				<Text>
					<WarningFilled color={'orange'} /> 강제 포지션 종료는
					포지션을 강제로 종료시키는 기능입니다.
				</Text>
				<Text>다시 한 번 확인해주세요.</Text>

				<Card>
					<Text style={{ marginBottom: 10 }}>
						사용자 :{' '}
						<UserTag
							userid={data?.user_id}
							onClick={onClick}
							email={data?.email}
							phone={data?.phone}
							nickname={data?.fullname || data?.nickname}
						/>
					</Text>
					<Contracts data={data} />

					<View
						style={{
							flexDirection: 'row',
							justifyContent: 'space-around',
							marginTop: 20,
						}}>
						<span>
							진입가:
							<Price
								price={data?.price}
								ep_id={data?.exchange_pairs_id}
							/>
						</span>
						<span>
							수량:
							<Quantity data={data} />
						</span>
						<span>
							미실현손익:
							<Unrealizedplpercent data={data} />
						</span>
					</View>
				</Card>
			</Modal>

			<CButton
				title={'포지션종료'}
				onClick={() => {
					setOpen(true)
				}}
				style={{
					background: COLORS.lightRed,
					color: COLORS.white,
					fontSize: 11,
					padding: '5px 5px',
				}}
			/>
		</>
	)
}

export default ClosePosition
